import v1tourOperators from './v1tourOperators'

export default [v1tourOperators]
